import styled from "styled-components";

export const ImageBadge = styled.img``;

export const Link = styled.a`
  cursor: pointer;
`;
